import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, Link, useParams } from 'react-router-dom'
import { getProducts } from '../../services/Services';
import './styles.css'
import Gimg from '../../images/icons/bgim.png';
import '../pages.global.css'
import ExploreAcademy from './explore.academy';
import { Container } from 'react-bootstrap';
import Fqahome from './Fqa.home';
import { Helmet } from 'react-helmet';
import MetaTag from '../../component/Common/MetaTag.tsx';

function ViewCourses() {
  const location = useLocation();
  const params = useParams();
  const { id, type, name, typeName } = params;
  const queryParams = new URLSearchParams(location.search);
  const { categoryName } = location.state || '';

  let category_id = 0;
  let category_name = '';
  let tag_name = '';
  let tag_id = 0;

  function capitalizeAndReplace(str) {
    // Split the string by "-"
    const words = str.split('-');

    // Capitalize the first letter of each word and join them with spaces
    const capitalizedStr = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

    return capitalizedStr;
  }

  if (type === 'c') {
    category_id = id;
    category_name = categoryName || capitalizeAndReplace(name);
  } else if (type === 't') {
    tag_name = capitalizeAndReplace(name);
    tag_id = id;
  }

  const topic = queryParams.get('topic');

  var Stitle = "";
  var Sdescription = "";
  var Skeyword = "";

  if (category_name == 'Courses for Universities-Colleges') {
    var Stitle = "Online Learning Platform for University & College Students | Q Academy";
    var Sdescription = "Explore Q Academy's platform with courses tailored for university and college students. Elevate education with our online learning programs designed for academic success.";
    var Skeyword = "online learning platform for university online learning platform for college";
  }

  if (category_name == 'Courses for Individuals') {
    var Stitle = "Online Courses for Individual Learning | Q Academy";
    var Sdescription = "Browse through Q Academy's extensive list of courses for individuals. Take your pick from various domains such as programming, data science, and more. Start your journey of personal growth with our online courses today!";
    var Skeyword = "online courses for individuals take individual courses online";
  }

  if (category_name == 'Self Paced') {
    var Stitle = "Self Paced Online Courses with Certificate | Q Academy";
    var Sdescription = "Q Academy's self-paced courses designed for flexible learning. Elevate your skills at your own pace with our self-paced online courses and earn certificates for your achievements.";
    var Skeyword = "self paced online courses with certificate";
  }

  if (category_name == 'Free') {
    var Stitle = "Free Online Courses and Certificates | Q Academy";
    var Sdescription = "Check Q Academy's free online courses and certificates. Gain valuable skills without cost. Enrich your learning journey with Q Academy's diverse range of free courses.";
    var Skeyword = "free online courses with certificates qacademy free courses";
  }

  if (category_name == 'Trending') {
    var Stitle = "Top Trending Online Courses in India | Q Academy";
    var Sdescription = "Discover the top trending online courses in India at Q Academy. Stay ahead with our list of the best trending online courses. Elevate your skills and knowledge with the latest trends.";
    var Skeyword = "top trending online courses online trending courses in india";
  }

  if (tag_name == 'Big Data') {
    var Stitle = "Best Big Data Online Courses, Training, & Certifications | Q Academy";
    var Sdescription = "Elevate your skills with the best big data online courses & training, including certifications. Learn Big Data online and stay ahead in the dynamic world of data analytics.";
    var Skeyword = "big data online courses best big data online course";
  }

  if (tag_name == 'Cloud Computing') {
    var Stitle = "Best Cloud Computing Online Courses, Classes, & Certifications | Q Academy";
    var Sdescription = "Explore best cloud computing courses online with certifications at Q Academy. Enroll in the best classes for cloud computing and advance your skills today.";
    var Skeyword = "cloud computing online courses with certificate best cloud computing courses online";
  }

  if (tag_name == 'Computer Science') {
    var Stitle = "Best Online Computer Science Courses & Certifications | Q Academy";
    var Sdescription = "Discover the best online computer science courses at Q Academy. Elevate your knowledge with top computer science online classes tailored for success in the tech world.";
    var Skeyword = "online computer science courses best computer science online courses";
  }

  if (tag_name == 'Cyber Security') {
    var Stitle = "Best Online Cyber Security Certifications Courses & Training | Q Academy";
    var Sdescription = "Master cyber security with Q Academy's online courses and certifications. Join the best cyber online security training for comprehensive skills and certifications.";
    var Skeyword = "best online cyber security courses online cyber security courses with certificates";
  }

  if (tag_name == 'Data Science') {
    var Stitle = "Best Online Information Technology Courses with Certifications | Q Academy";
    var Sdescription = "Unlock the future of IT with Q Academy's online courses. Explore the best information technology online classes and certifications for a successful IT career.";
    var Skeyword = "";
  }

  if (tag_name == 'Software Development') {
    var Stitle = "Online Software Development Courses, Classes & Certifications | Q Academy";
    var Sdescription = "Elevate your coding skills with Q Academy's online software development courses. Enroll in the best online  software development classes and become a skilled developer.";
    var Skeyword = "online software development courses software development courses online";
  }





  const dispatch = useDispatch();
  useEffect(() => {
    getProducts(0, category_id || 0, tag_id || 0, dispatch);
  }, [category_id, tag_id]);

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const [activBtn, setactiveBtn] = useState(tag_id);
  const { tags, courses } = useSelector(state => state.course);
  const [bottomSelectedTag, setBottomSelcetedTag] = useState();


  // let images = [
  //   "https://cdn.pixabay.com/photo/2017/02/06/11/58/desert-2042738_1280.jpg",
  //   "https://cdn.pixabay.com/photo/2016/11/29/08/51/forest-1868529_1280.jpg",
  //   "https://images.pexels.com/photos/5531009/pexels-photo-5531009.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  //   "https://images.pexels.com/photos/3721098/pexels-photo-3721098.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  //   "https://images.pexels.com/photos/4992804/pexels-photo-4992804.jpeg?auto=compress&cs=tinysrgb&w=600",
  //   "https://images.pexels.com/photos/6271651/pexels-photo-6271651.jpeg?auto=compress&cs=tinysrgb&w=600",
  //   "https://images.pexels.com/photos/5065312/pexels-photo-5065312.jpeg?auto=compress&cs=tinysrgb&w=600"
  // ]


  const coursesimages = [
    { image: require('../../images/imageone.png') },
    { image: require('../../images/imagetwo.png') },
    { image: require('../../images/imagethree.png') },
    { image: require('../../images/imagefour.png') },
    { image: require('../../images/imagefive.png') },
    { image: require('../../images/imageone.png') },
    { image: require('../../images/imagetwo.png') },
    { image: require('../../images/imagethree.png') },
    { image: require('../../images/imagefour.png') },
    { image: require('../../images/imagefive.png') },
    { image: require('../../images/imageone.png') },
    { image: require('../../images/imagetwo.png') },
    { image: require('../../images/imagethree.png') },
    { image: require('../../images/imagefour.png') },
    { image: require('../../images/imagefive.png') },
    { image: require('../../images/imagetwo.png') },
    { image: require('../../images/imagethree.png') },
    { image: require('../../images/imagefour.png') },
    { image: require('../../images/imagefive.png') },
    { image: require('../../images/imageone.png') },
    { image: require('../../images/imagetwo.png') },
    { image: require('../../images/imagethree.png') },
    { image: require('../../images/imagefour.png') },
    { image: require('../../images/imagefive.png') },
  ];


  const [splice_value, setsplice_value] = useState(6);
  const [btn_txt, setbtn_txt] = useState('Show all');

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function showALl_and_fewer() {
    document.getElementById('scroll-up').scrollIntoView();
    if (splice_value === 6) {
      setsplice_value(courses.length);
      setbtn_txt('Show fewer');
    }
    else {
      setsplice_value(6);
      setbtn_txt('Show all');
    }
  }
  function onBottomTagsClick(id, name) {
    setBottomSelcetedTag(name)
    setactiveBtn(id);
    getProducts(0, 0, id, dispatch);
    window.scrollTo(0, 0);
  }

  const text = tag_name || category_name || bottomSelectedTag || '';
  let combinedText = '';

  var breakTagl = 12;

  if (text.length > breakTagl) {
    const substrings = [];
    for (let i = 0; i < text.length; i += breakTagl) {
      substrings.push(text.substring(i, i + breakTagl));
    }
    combinedText = substrings.join('\n');
  } else {
    combinedText = text;
  }
  return (
    <>
      <MetaTag title={tag_name || name || bottomSelectedTag || ''} />
      <div className='d-flex  d-lg-block' style={{
        height: '50vh',
        backgroundImage: `url(${Gimg})`,
        backgroundSize: 'cover',
        width: '100%',
        position: 'relative',
        padding: '0 7rem',
      }}>
        <h3 className="fs-1 fs-md-4 roboto h-100 d-flex align-items-center" style={{
          letterSpacing: '0.02rem',
          lineHeight: '1.2',
          textAlign: 'left',
          minHeight: '100px' /* Set a minimum height for vertical centering */
        }}>

          <Container >
            <div className='bannerStyleofViewAllCourses' dangerouslySetInnerHTML={{ __html: category_name || tag_name || bottomSelectedTag }} />
          </Container>
        </h3>

      </div>
      <div className='pb-5 pt-0 pt-lg-5 mt-md-5'>
        <div className='container'>
          <div className='row'>
            <p className='mt-md-0 mt-3 roboto' style={{
              color: '#000',
              fontSize: '1.5rem',
              fontWeight: 'medium',
              lineHeight: '1.2',
              letterSpacing: '0.01rem',
              // marginTop: '1rem',
            }}
            >
              <b>Browse </b><b dangerouslySetInnerHTML={{ __html: category_name || tag_name || bottomSelectedTag }} />
            </p>
            {category_name === ' degrees' && (
              <>
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  // gap: '0.1rem',
                  width: '100%',
                  marginBottom: '1.5rem'
                }}>
                  <span className='text-black roboto' id="scroll-up"><b>Browse by</b></span>
                  {tags.map((tag, index) => {
                    return (
                      <button key={index} className={`course-btn ${activBtn == tag.id && 'custom-activ-btn'}`} onClick={() => {
                        getProducts(0, 0, tag.id, dispatch);
                        setactiveBtn(tag.id)
                      }}>{tag.name}</button>
                    )
                  })
                  }
                </div>
              </>
            )}
            <div className='container' id="scroll-up">
              <div className='row'>
                {
                  courses.slice(0, splice_value).map((tag, i) => ( // Added parentheses to return the JSX
                    <Link to={`/course/${tag.slug}`} className='col-lg-4 col-md-6  mb-5 custom-link roboto' style={{
                      textDecoration: 'none',
                      color: '#000',
                    }} key={i}>
                      <div className="card action-trigger-hover roboto bg-transparent m-3  CardHover h-100" style={{
                      }}>
                        <div className="card-img-container">
                          <img
                            src={
                              ![null, undefined, " ", '', 'undefined'].includes(tag?.image)
                                ? tag?.image
                                : 'https://placehold.co/400'
                            }
                            className="card-img-top slider-card-img"
                            alt="course image"
                            style={{
                              height: '200px',
                              objectFit: 'cover',
                              width: '100%',
                            }}
                          />
                        </div>
                        <div className="card-body pb-2"> {/* Updated class: pb-2 */}
                          <img
                            className="light-mode-item navbar-brand-item"
                            src="/assets/images/logo.webp"
                            alt="logo"
                            style={{ width: "110px", height: "25px", objectFit: 'cover' }} // Adjust the width and height to your desired size
                          />
                          <h5 className="card-title mb-2 my-3" style={{
                          }}> {/* Updated class: mb-2 */}
                            <Link to={`/course/${tag.slug}`} state={{ id: tag.id }}>
                              <a
                                className='h5 roboto'
                                style={{
                                  color: '#000', fontSize: '17px', fontWeight: '500', letterSpacing: '0.01rem', overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  display: '-webkit-box',
                                  WebkitLineClamp: '1',
                                  WebkitBoxOrient: 'vertical',
                                }} dangerouslySetInnerHTML={{ __html: tag?.name }} />
                            </Link>
                          </h5>
                          <div>
                            <p
                              className="caption roboto"
                              style={{
                                fontSize: '15px',
                                fontWeight: '200', /* Adjust the font weight to 300 for thinner text */
                                lineHeight: '1.5',
                                // height: '50px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                display: '-webkit-box',
                                WebkitLineClamp: '2',
                                WebkitBoxOrient: 'vertical',
                                letterSpacing: '0.01rem', /* Adjust the letter spacing for thinner text */
                                color: '#363434',
                              }}
                              dangerouslySetInnerHTML={{ __html: tag.description }} />
                          </div>
                        </div>
                        <div className="card-footer pt-0 bg-transparent">
                          <b className='rating-count text-black mx-1 caption'>4.8 <i className="fas fa-star text-primary" style={{
                            fontSize: '12px',
                          }}></i><span style={{ fontWeight: '100', fontSize: '12px' }}> (30 reviews)</span></b>
                          <div className="d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center">
                              <span className='caption mt-1 roboto' style={{
                                fontSize: '13px',
                                color: '#000',
                                letterSpacing: '0.001rem',
                                fontWeight: '200', /* Adjust the font weight to 300 for thinner text */
                              }}>{capitalizeFirstLetter(tag.level)} | Professional Certificate |  {tag.duration.hours} Hours</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))
                }

              </div>
              {
                courses.length > 6 &&
                <div className='cotainer d-flex justify-content-center align-content-center mt-1'>
                  <button className='showall-btn roboto' onClick={() => showALl_and_fewer()}>{btn_txt} {courses.length <= 6 || btn_txt == 'Show fewer' ? '' : courses.length}</button>
                </div>
              }
            </div>
          </div>


          {/* this for explore more degree by category */}

          {/* <div className='row mt-4'>
            <h4 className='roboto'>Explore more degree by category</h4>
            <div className='row'>
              {tags.map((tag, i) => (
                <Link key={tag.id} onClick={() => onBottomTagsClick(tag.id, tag.name)} className='col-lg-6 mt-4'>
                  <div className="card" style={{
                    boxShadow: '1px 1px 1px rgba(0,0,0,0.2)',
                    borderRadius: '5px'
                  }}>
                    <img
                      className='image-container'
                      src={images[i]}
                      alt=""
                      style={{
                        height: '70px',
                        width: '100%',
                        objectFit: 'cover',
                        borderRadius: '5px',
                        transform: 'scale(1.0)',
                        filter: 'blur(1px)',
                      }}
                    />
                    <p className='roboto' style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      color: '#fff',
                    }}>
                      <b>{tag.name}</b>
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          </div> */}
        </div>
      </div>
      {/* <ExploreAcademy isShow={false} /> */}
      <Fqahome />
    </>
  )
}

export default ViewCourses